/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadDiagnosis } from './LeadDiagnosis';
import {
    LeadDiagnosisFromJSON,
    LeadDiagnosisFromJSONTyped,
    LeadDiagnosisToJSON,
} from './LeadDiagnosis';

/**
 * 
 * @export
 * @interface LeadDiagnoses
 */
export interface LeadDiagnoses {
    /**
     * Timestamp when ICD-10 extraction last completed for the lead
     * @type {Date}
     * @memberof LeadDiagnoses
     */
    extracted_at: Date;
    /**
     * 
     * @type {Array<LeadDiagnosis>}
     * @memberof LeadDiagnoses
     */
    diagnoses: Array<LeadDiagnosis>;
}

/**
 * Check if a given object implements the LeadDiagnoses interface.
 */
export function instanceOfLeadDiagnoses(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "extracted_at" in value;
    isInstance = isInstance && "diagnoses" in value;

    return isInstance;
}

export function LeadDiagnosesFromJSON(json: any): LeadDiagnoses {
    return LeadDiagnosesFromJSONTyped(json, false);
}

export function LeadDiagnosesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDiagnoses {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'extracted_at': (new Date(json['extracted_at'])),
        'diagnoses': ((json['diagnoses'] as Array<any>).map(LeadDiagnosisFromJSON)),
    };
}

export function LeadDiagnosesToJSON(value?: LeadDiagnoses | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'extracted_at': (value.extracted_at.toISOString()),
        'diagnoses': ((value.diagnoses as Array<any>).map(LeadDiagnosisToJSON)),
    };
}

